import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import {
  BrowserRouter,
  Route,
  Routes,
} from 'react-router-dom';
import store from './app/store';
import { Provider } from 'react-redux';

// Always import these styles
import 'remixicon/fonts/remixicon.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// conditional
import('./tailwind.css');
import('travelyo-react-shared-components/dist/index.css');
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import he from 'date-fns/locale/he';
import de from 'date-fns/locale/de';
import enGB from 'date-fns/locale/en-GB';
import { LOCALE } from './constants';

const App = lazy(() => import('./App'));
const FavoritePage = lazy(() => import('./features/favorite/FavoritePage'));
const ProposalView = lazy(() => import('./features/proposals/ProposalView'));
const ProposalsPage = lazy(() => import('./features/proposals/ProposalsPage'));
const GroupBooking = lazy(() => import('./features/groupBooking/GroupBooking'));

// Loading component for route chunks
const RouteLoading = () => (
  <div className="route-loading">
    <div className="loading-spinner" />
  </div>
);

if (LOCALE === 'he') {
  registerLocale('he', he);
  setDefaultLocale('he');
}
if (LOCALE === 'de') {
  registerLocale('de', de);
  setDefaultLocale('de');
}

if (LOCALE === 'en') {
  registerLocale('en-GB', enGB);
  setDefaultLocale('en-GB');
}

let intRoute = window.location.pathname;
if (intRoute.includes('favorites')) {
  intRoute = intRoute.slice(0, intRoute.indexOf('favorites'));
}

if (intRoute.includes('offline-booking')) {
  intRoute = intRoute.slice(0, intRoute.indexOf('offline-booking'));
}

if (intRoute.includes('proposals')) {
  intRoute = intRoute.slice(0, intRoute.indexOf('proposals'));
}

if (intRoute.includes('proposal/view')) {
  intRoute = intRoute.slice(0, intRoute.indexOf('proposal/view'));
}

const favoriteRoute = intRoute + 'favorites';
const proposalsRoute = intRoute + 'proposals';
const proposalViewRoute = intRoute + 'proposal/view/:id';
const offlineBookingRoute = intRoute + 'offline-booking';
const container = document.getElementById('app');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Suspense fallback={<RouteLoading />}>
          <Routes>
            <Route
              path={intRoute}
              element={<App />}
            />
            <Route
              path={favoriteRoute}
              element={<FavoritePage intRoute={intRoute} />}
            />
            <Route
              path={offlineBookingRoute}
              element={<GroupBooking />}
            />
            <Route
              path={proposalsRoute}
              element={<ProposalsPage />}
            />
            <Route
              path={proposalViewRoute}
              element={<ProposalView />}
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
